import React, { useState, useRef, useEffect } from "react";
import { KendoTreeTable } from "../../Kendo/kendo_treetable";
import {
  Button,
  ErrorMsg,
  CommonErrorMsg,
  ValidateForm,
  confirmDelete,
  sessionUser,
  InfoIcon,
} from "../../Util/common";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoDatePicker } from "../../Kendo/kendo_datepicker";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { toast } from "react-toastify";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const Gallery_Main = () => {
  const [error, setError] = useState({});
  const [refreshflag, setrefreshflag] = useState(0);
  const [removedImageIds, setRemovedImageIds] = useState();
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState("");
  const modalRef = useRef(null);
  const [imageList, setImageList] = useState([]);
  const imageListRef = useRef(imageList);
  const [dragging, setDragging] = useState(null);
  const [selectedImageID, setSelectedImageID] = useState(null);
  const [editVisible, setEditVisible] = useState(false);

  const [Gallery, setGallery] = useState({
    GalleryID: 0,
    DisplayedInID: 0,
    DisplayedInName: "",
    EventTypeID: 0,
    EventTypeName: "",
    EventTitle: "",
    ImagesModel: [],
    EventDate: "",
    Images: [],
    OldimagePath: [],
    ImageSortOrder: 0,
  });
  const [Loading, setLoading] = useState(false);
  const Parentscolumns = [
    {
      field: "displayedInID",
      filterable: false,
      hidden: true,
    },

    {
      field: "eventName",
      title: "Displayed In",
    },
  ];

  const childColumn = [
    { field: "galleryID", hidden: true },
    {
      field: "displayedInID",
      hidden: true,
    },
    {
      field: "eventTypeID",
      filterable: false,
      hidden: true,
    },
    {
      field: "displayedInName",
      hidden: true,
    },
    {
      field: "eventTypeName",
      hidden: true,
    },
    { field: "eventTitle", title: "Event Title" },
    {
      field: "eventDate",
      title: "Event Date",
      template: function (dataItem) {
        var eventDate = kendo.toString(
          kendo.parseDate(dataItem.eventDate),
          "MM/dd/yyyy"
        );
        return eventDate || "";
      },
    },
    {
      field: "imagePath",
      hidden: true,
    },
  ];

  const clearForm = () => {
    setGallery({
      GalleryID: 0,
      DisplayedInID: 0,
      DisplayedInName: "",
      EventTypeID: 0,
      EventTypeName: "",
      EventTitle: "",
      ImagesModel: [],
      EventDate: "",
      Image: [],
      OldimagePath: [],
    });

    setImage("");
    setError({});
    setEditVisible(false);
    setRemovedImageIds("");
    setImageList("");
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
    setSelectedImageID(0);
  };

  const onValidation = (name, val) => {
    setError((prevErr) => ({
      ...prevErr,
      [name]: !val || val.trim() === "",
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const err = ValidateForm(e);
    if (err) {
      setError(err);
      return;
    }
    const hasCoverPhoto = imageList.some((img) => img.isCoverPhoto === 1);
    if (!hasCoverPhoto) {
      toast.error("Please select a cover photo before submitting!");
      return;
    }

    const formData = new FormData();

    if (
      Gallery.Images &&
      Array.isArray(Gallery.Images) &&
      Gallery.Images.length > 0
    ) {
      Gallery.Images.forEach((file) => {
        formData.append("Images", file);
      });
    }
    if (removedImageIds && removedImageIds.length > 0) {
      formData.append("RemovedImageIds", removedImageIds);
    }
    imageList.forEach((imageModel, index) => {
      if (imageModel) {
        const uniqueImageID = imageModel.imageID || 0;
        formData.append(
          `ImageModels[${index}].ImageID`,
          imageModel.imageID || 0
        );
        formData.append(
          `ImageModels[${index}].GalleryID`,
          imageModel.galleryID || 0
        );
        formData.append(
          `ImageModels[${index}].ImagePath`,
          imageModel.imagePath || ""
        );
        formData.append(
          `ImageModels[${index}].SortOrder`,
          imageModel.SortOrder || 0
        );
        formData.append(
          `ImageModels[${index}].Images`,
          imageModel.fileData || ""
        );
        formData.append(
          `ImageModels[${index}].IsCoverPhoto`,
          imageModel.isCoverPhoto || 0
        );
        // const isCoverPhoto =
        //   selectedImageID === (imageModel.imageID || index) ? 1 : 0;
        // formData.append(`ImageModels[${index}].IsCoverPhoto`, isCoverPhoto);
      }
    });

    formData.append("GalleryID", Gallery.GalleryID);
    formData.append("DisplayedInID", Gallery.DisplayedInID);
    formData.append("EventTypeID", Gallery.EventTypeID);
    formData.append("EventTitle", Gallery.EventTitle);
    formData.append(
      "EventDate",
      Gallery.EventDate
        ? new Date(Gallery.EventDate).toLocaleString()
        : new Date().toLocaleString()
    );
    formData.append("OldimagePath", Gallery.OldimagePath);
    formData.append("SelectedImageID", selectedImageID || 0);
    setLoading(true);
    try {
      await corepost(
        "Gallery/UploadGalleryImages",
        formData,
        true,
        true,
        false,
        false
      );
      setLoading(false);
      clearForm();
      $("#close").click();

      refreshChildGrd();
    } catch (error) {
      console.error("Error while submitting the form:", error);
    }
  };

  const onEditClick = (e) => {
    setTitle(e.eventName);
    setGallery((prevBlog) => ({
      ...prevBlog,
      DisplayedInID: e.displayedInID,
    }));
    $("#add_Gallery").modal("show");
  };

  const handleDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null || selectedDate == "") {
      setGallery((prev) => ({
        ...prev,
        EventDate: null,
      }));
      setError((prevErr) => ({
        ...prevErr,
        EventDate: true,
      }));
    } else {
      setGallery((prev) => ({
        ...prev,
        EventDate: selectedDate,
      }));
      setError((prevErr) => ({
        ...prevErr,
        EventDate: false,
      }));
    }
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validImages = files.filter((file) => file.type.startsWith("image/"));
    const hasAvifFile = files.some(
      (file) => file.type === "image/avif" || file.name.endsWith(".avif")
    );

    if (hasAvifFile) {
      toast.error("Uploaded images contain unsupported formats.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (validImages.length !== files.length) {
      setError({ ValidFile: true });
    } else {
      const newImageList = validImages.map((file, index) => ({
        imagePath: URL.createObjectURL(file),
        fileName: file.name,
        fileData: file,
        Id: index,
        selectedAsCover: false,
        Images: validImages,
        isCoverPhoto: 0,
      }));

      setImageList((prevImages) => [...prevImages, ...newImageList]);
      setGallery((prevState) => ({
        ...prevState,
        Images: prevState.Images
          ? [...prevState.Images, ...validImages]
          : [...validImages],
      }));
      // onValidation("Image", event.target.value);
      event.target.value = "";
    }
  };

  useEffect(() => {}, [Gallery, imageList]);

  const handleFunctionEditClick = (e) => {
    setTitle(e.parent.eventName);
    let imgModel = [];
    if (e.child.imageModels) {
      for (let i = 0; i < e.child.imageModels.length; i++) {
        imgModel.push(e.child.imageModels[i]);
      }
    }
    setGallery({
      DisplayedInID: e.parent.displayedInID,
      GalleryID: e.child.galleryID,
      EventTypeID: e.child.eventTypeID,
      EventTitle: e.child.eventTitle,
      Images: e.child.eventTitle,
      ImagesModel: imgModel
        ? imgModel.map((x) => {
            return {
              Path: x.imagePath,
              Id: x.imageID,
              SortOrder: x.sortOrder,
            };
          })
        : [],
      OldimagePath: e.child.imageModels?.[0]?.imagePath || "",
      EventDate: e.child.eventDate,
    });
    setImageList(imgModel);
    setEditVisible(true);

    const modal = new bootstrap.Modal(document.getElementById("add_Gallery"));
    modal.show();
  };
  const refreshChildGrd = () => {
    $(`#reload-eventandfunctions`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };
  const handleDeleteClick = async (e) => {
    const onDelete = async () => {
      let SavedBy = sessionUser();
      await corefetch(
        `Gallery/DeleteGallery?id=${e.galleryID}&deletedBy=${SavedBy}`,
        true,
        false,
        true
      );
      refreshChildGrd();
    };
    confirmDelete(onDelete);
  };

  const handleRemoveImage = (imageId, index) => {
    try {
      const wasCoverPhoto = imageList[index]?.isCoverPhoto === 1;
      const updatedImageList = imageList.filter((_, i) => i !== index);

      if (wasCoverPhoto && updatedImageList.length > 0) {
        // If the removed image was the cover photo, assign the first image as the new cover photo
        updatedImageList[0].isCoverPhoto = 1;
        setSelectedImageID(updatedImageList[0].imageID || 0); // Update selectedImageID
      }

      setImageList(updatedImageList);

      setRemovedImageIds((prevRemovedIds = "") =>
        [...prevRemovedIds.split(","), imageId].filter(Boolean).join(",")
      );

      setGallery((prevGallery) => ({
        ...prevGallery,
        Images: updatedImageList.map((item) => item.fileData || item),
      }));
    } catch (error) {
      console.error("Error removing image:", error);
    }
  };

  useEffect(() => {
    imageListRef.current = imageList;
  }, [imageList]);

  const handleImageSelect = (img, index) => {
    try {
      const updatedImageList = imageList.map((image, idx) => ({
        ...image,
        isCoverPhoto: idx === index ? 1 : 0,
      }));

      setImageList(updatedImageList);

      // Set the selected image ID, either existing or temporary (index)
      setSelectedImageID(img.imageID || index);

      // refreshChildGrd();
    } catch (error) {
      console.error("Error selecting image:", error);
    }
  };

  const handleDragStart = (e, index) => {
    setDragging(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, index) => {
    const newList = [...imageList];
    const draggedItem = newList.splice(dragging, 1)[0];
    newList.splice(index, 0, draggedItem);
    newList.forEach((item, newIndex) => {
      item.SortOrder = newIndex + 1;
    });
    setImageList(newList);
    setGallery((prevGallery) => ({
      ...prevGallery,
      Images: newList.map((item) => item.fileData || item),
    }));
    setDragging(null);
  };

  return (
    <div className="container-fluid">
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Gallery</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Gallery</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="col-auto ms-auto">
        <KendoTreeTable
          name={"eventandfunctions"}
          parentTableColumns={Parentscolumns}
          parentTableUrl={CorebaseURL + "Gallery/GetDisplayesInListForBallroom"}
          childTableUrl={
            CorebaseURL +
            "Gallery/GetGalleryDetails?displayedinID={displayedInID}"
          }
          childSchema={{
            imageID: { type: "number" },
            galleryID: { type: "number" },
            imagePath: { type: "string" },
            sortOrder: { type: "number" },
          }}
          childTableColumns={childColumn}
          onParentEditClick={onEditClick}
          showParentOptions={true}
          showParentDelete={false}
          showChildOptions={true}
          showChildEdit={true}
          showChildDelete={true}
          onChildEditClick={handleFunctionEditClick}
          onChildDeleteClick={handleDeleteClick}
          refreshWhen={refreshflag}
          childTableData={(parent) => {
            return Array.isArray(parent.imageModels) ? parent.imageModels : [];
          }}
        />

        {/* Add Function Modal */}
        <div
          className="modal custom-modal fade"
          id="add_Gallery"
          role="dialog"
          ref={modalRef}
          aria-hidden="true"
          data-bs-backdrop="static"
        >
          <div
            className="modal-dialog modal-dialog-centered gallery"
            role="document"
            style={{ width: "900px" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>

                <button
                  type="button"
                  id="close"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={clearForm}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {/* Form to add event details */}
                <form id="event-form" onSubmit={onSubmit}>
                  <div className="row align-items-end">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Event Type <span className="text-danger">*</span>
                      </label>
                      <KendoDropdown
                        name="BallroomID"
                        url={
                          CorebaseURL + "Gallery/GetDisplayesInListForEvents"
                        }
                        value={Gallery.EventTypeID}
                        dataTextField="eventName"
                        dataValueField="displayedInID"
                        placeholder="Select event type"
                        required={true}
                        onValidation={onValidation}
                        onChange={(e) => {
                          setGallery((prevEvents) => ({
                            ...prevEvents,
                            EventTypeID: e,
                          }));
                          onValidation("BallroomID", e);
                        }}
                      />
                      <CommonErrorMsg
                        text="Event Type is required"
                        IsError={error.BallroomID}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="form-label">
                          Event Date <span className="text-danger">*</span>
                        </label>
                        <KendoDatePicker
                          name="EventDate"
                          value={Gallery.EventDate}
                          placeholder={"Select Date"}
                          required={true}
                          format={"MM/dd/yyyy"}
                          onChange={handleDateChange}
                        />
                        <CommonErrorMsg
                          text="Event Date is required"
                          IsError={error.EventDate}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Event Title <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Event Title Type with a maximum length of 50 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        className="form-control"
                        name="EventTitle"
                        value={Gallery.EventTitle}
                        placeholder="Enter event title"
                        data-required="true"
                        onChange={(e) => {
                          setGallery((prev) => ({
                            ...prev,
                            EventTitle: e.target.value,
                          }));
                          onValidation("EventTitle", e.target.value);
                        }}
                      />
                      <CommonErrorMsg
                        text="Event Title is required"
                        IsError={error.EventTitle}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="form-label">
                          Upload Image <span className="text-danger">*</span>
                          <InfoIcon
                            content="Please ensure each image is uploaded within a maximum size of 500KB;
                          Please upload the images in JPEG,JPG or PNG format."
                          />
                        </label>
                        <input
                          id="lFile"
                          className="form-control"
                          type="file"
                          name="Image"
                          accept="image/*"
                          multiple
                          onChange={handleFileChange}
                        />

                        <CommonErrorMsg
                          text={
                            error.Image
                              ? "Image is required"
                              : "please upload Image file only"
                          }
                          IsError={error.Image || error.ValidFile}
                        />
                      </div>
                    </div>
                    <div
                      className="col-md-12"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {imageList &&
                        imageList.length > 0 &&
                        imageList.map((img, index) => (
                          <div
                            key={index}
                            className="list-item"
                            style={{
                              position: "relative",
                              display: "inline-block",
                              textAlign: "center",
                              width: "120px", // Fixed width
                              height: "140px",
                              backgroundColor:
                                selectedImageID === img?.imageID ||
                                img.isCoverPhoto === 1
                                  ? "#ffedd7"
                                  : "transparent",
                            }}
                            onClick={() => handleImageSelect(img, index)}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={handleDragOver}
                            onDrop={(e) => handleDrop(e, index)}
                          >
                            <input
                              type="radio"
                              className="imgFlagContainer"
                              id="age1"
                              name="age"
                              style={{ display: "none" }}
                              value={img?.Id}
                              // onChange={handleSelection}
                            />
                            <img
                              src={
                                img?.imageID > 0
                                  ? ImageURL + img?.imagePath
                                  : img?.imagePath
                              }
                              alt={img.imagePath.split("/").pop()}
                              style={{
                                maxWidth: "100px",
                                minWidth: "100px",
                                height: "100px",
                                display: "block",
                                margin: "0 auto",
                              }}
                            />
                            {img.isCoverPhoto === 1 && (
                              <h6
                                style={{
                                  margin: "5px 0 0",
                                  fontSize: "12px",
                                  lineHeight: "1.2",
                                  height: "auto", // Ensure it adjusts based on the content, but height won't grow unexpectedly
                                  overflow: "hidden",
                                }}
                              >
                                Cover Image
                              </h6>
                            )}
                            <button
                              style={{
                                position: "absolute",
                                top: "-10px",
                                right: "-10px",
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                              }}
                              className="close"
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveImage(img?.imageID, index);
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))}

                      {/* ) : ""} */}
                      <input
                        type="hidden"
                        name="Image"
                        id="image-name"
                        data-required="true"
                        value={Gallery.Images || ""}
                      />
                      <input
                        type="hidden"
                        name="OldimagePath"
                        value={Gallery.OldimagePath}
                      />
                    </div>
                    {Loading ? (
                      <KendoLoader className="d-flex justify-content-end align-items-center" />
                    ) : (
                      <div className="text-end btn-mt">
                        <Button
                          name={"Cancel"}
                          isCancelButton={true}
                          id="gallery-cancel"
                          dataBsDismiss={"modal"}
                          onClick={clearForm}
                        />

                        <Button name={editVisible ? "Update" : "Save"} />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
